import type { FaireProductEntity } from "../../entity_types/product";

export const fiore_aperitivo: FaireProductEntity = {
  token: "fiore-aperitivo",
  type: "product",
  name: "Fiore Non-Alcoholic Aperitivo",
  brandName: "Figlia",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/55fabe0e90f2e100821208a64ed633af6e1cebb5a1bfabe932910c73a0a4ee51.webp",
  priceDollars: 19,
  msrpDollars: 38,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
